import Chart, { ChartProps } from "../../Components/Chart";
import { useAsync } from "react-use";
import moment from "moment";
import axios from "axios";
import compoundIdsQuery from "./compoundIdsQuery";

interface DailyMovement {
	date: string;
	ingoing: number;
	outgoing: number;
}

interface CompoundReturnsChartProps extends Partial<ChartProps> {
	compoundIds: string[];
}

export default ({ compoundIds, ...props }: CompoundReturnsChartProps) => {
	// react-use's useAsync compares deps by reference; compoundIds is a new array on every
	// parent render, so depend on a stable joined string instead to avoid an infinite fetch loop.
	const compoundIdsKey = compoundIds.join(",");

	const chartData = useAsync(async () => {
		if (compoundIds.length === 0) {
			return [];
		}

		const endOfThisMonth = moment().endOf("month");
		const beginningOfThisMonth = moment().startOf("month").subtract(1, "month");

		const response = await axios.post<DailyMovement[]>(
			`/api/compounds/kpis/vehicle-movements?${compoundIdsQuery(compoundIds)}`,
			{
				dateFrom: beginningOfThisMonth.format(moment.HTML5_FMT.DATE),
				dateTo: endOfThisMonth.format(moment.HTML5_FMT.DATE)
			}
		);

		const ingoingSeries = {
			name: "ingoing",
			title: "Fahrzeugeingänge",
			data: response.data.map((s) => ({
				x: s.date,
				y: s.ingoing
			}))
		};

		const outgoingSeries = {
			name: "outgoing",
			title: "Fahrzeugausgänge",
			data: response.data.map((s) => ({
				x: s.date,
				y: s.outgoing
			}))
		};

		const differenceSeries = {
			name: "differences",
			title: "Bilanz",
			data: response.data.map((s) => ({
				x: s.date,
				y: s.ingoing - s.outgoing
			}))
		};

		return [ingoingSeries, outgoingSeries, differenceSeries];
	}, [compoundIdsKey]);

	return <Chart {...props} loading={chartData.loading} series={chartData.value || []} />;
};
